<script setup lang="ts">
import { computed } from 'vue';
import { useUxData } from '@/stores/ux-data';

withDefaults(defineProps<{ active?: boolean }>(), { active: false });
const emit = defineEmits<{ open: [] }>();

const ux = useUxData();
const label = computed(() => (ux.labels as any)?.filters?.toggleLabel ?? 'Filters');
</script>

<template>
  <button type="button" class="btn btn-sm btn-light filter-toggle d-lg-none" @click="emit('open')">
    <span class="fa-light fa-filter" aria-hidden="true"></span>
    <span class="filter-toggle-label">{{ label }}</span>
    <span v-if="active" class="filter-toggle-badge" aria-hidden="true"></span>
  </button>
</template>
